<template>
  <div class="caca">
    <h2><v-icon color="error" class="mr-1">error</v-icon>{{ $t('Payments.PNM.NotCompleted.Headline') }}</h2>
    <div v-if="errorMessage">
      {{errorMessage}}
      <div v-if="errorReference">
        {{ $t('Account.TransactionHistory.History.Reference') }}: 
        {{errorReference}}
      </div>
    </div>
    <div v-else>{{ $t('Payments.PNM.NotCompleted.Payment') }}</div>
    <!-- Back to homepage -->
    <div class="goto__home">
      <v-btn large color="success" @click="goToHomepage()">{{ $t('Account.ChangePassword.GoToHomepage') }}</v-btn>
    </div>
    <NuveiEventDispatcher :paymentIsCompleted="false"/>
  </div>
</template>
<script>
import NuveiEventDispatcher from '@/components/payments/Nuvei/NuveiEventDispatcher'
import store from '@/store'
import { i18n } from '@/library/locale/i18n'

export default {
  components: {
    NuveiEventDispatcher
  },
  computed: {
    errorMessage () {
      let message = store.getters[`nuvei/${this.currentNuveiType}/getErrorMessage`]
      if (message === 'authOperationCancelled') {
        message = i18n.t('Payments.AuthOperationCancelled')
      }
      return message
    },
    currentNuveiType () {
      return store.getters['nuvei/currentNuveiType']
    },
    errorReference () {
      return store.getters[`nuvei/${this.currentNuveiType}/getErrorReference`]
    }
  },
  methods: {
    goToHomepage () {
      this.$router.push({name: 'sports'})
    }
  }
}
</script>
<style lang="stylus" scoped>
@import "~@/css/config"
.caca
  @media mobile-big-and-below
    background white
    padding 10px
  .goto__home
    margin-top 10px
    text-align center
</style>



// WEBPACK FOOTER //
// src/components/payments/Nuvei/NuveiPaymentFailed.vue